var _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgCall(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 256,
    height: 256,
    viewBox: "0 0 256 256",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null)), /*#__PURE__*/React.createElement("g", {
    style: {
      stroke: "none",
      strokeWidth: 0,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 10,
      fill: "none",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: "translate(1.4065934065934016 1.4065934065934016) scale(2.81 2.81)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 65.96 90 c -13.131 0 -29.861 -7.918 -43.924 -22.062 C 12.03 57.876 4.796 46.187 1.667 35.024 c -3.243 -11.566 -1.722 -21.262 4.283 -27.3 c 0.218 -0.219 0.44 -0.431 0.668 -0.637 c 0.059 -0.082 0.124 -0.16 0.198 -0.233 l 3.202 -3.22 c 1.548 -1.557 3.607 -2.415 5.796 -2.415 c 2.189 0 4.248 0.858 5.796 2.415 l 12.281 12.35 c 3.196 3.215 3.196 8.445 0 11.659 l -5.26 5.29 c -1.315 1.323 -1.315 3.475 0 4.797 l 23.443 23.576 c 1.275 1.281 3.496 1.281 4.77 0 l 5.26 -5.29 c 3.196 -3.214 8.398 -3.214 11.594 0 l 12.28 12.35 c 3.197 3.214 3.197 8.446 0 11.66 l -3.202 3.22 c -0.074 0.075 -0.153 0.143 -0.235 0.203 c -0.204 0.227 -0.413 0.45 -0.63 0.667 C 77.944 88.105 72.383 90 65.96 90 z M 9.915 9.399 c -0.098 0.156 -0.219 0.3 -0.361 0.422 c -0.271 0.234 -0.535 0.478 -0.789 0.734 c -4.94 4.968 -6.1 13.272 -3.265 23.383 c 2.947 10.514 9.82 21.583 19.352 31.17 c 19.39 19.5 43.723 26.758 54.245 16.178 c 0.256 -0.257 0.499 -0.524 0.734 -0.797 c 0.126 -0.149 0.273 -0.276 0.434 -0.378 l 2.898 -2.915 c 1.644 -1.654 1.644 -4.344 0 -5.998 l -12.28 -12.35 c -0.797 -0.801 -1.856 -1.242 -2.982 -1.242 s -2.185 0.442 -2.981 1.242 l -5.261 5.29 c -1.388 1.397 -3.235 2.166 -5.199 2.166 c -1.964 0 -3.811 -0.769 -5.2 -2.166 L 25.815 40.562 c -2.867 -2.884 -2.867 -7.575 0 -10.459 l 5.26 -5.29 c 1.644 -1.654 1.645 -4.345 0 -5.998 L 18.795 6.464 c -0.797 -0.801 -1.856 -1.242 -2.982 -1.242 c -1.127 0 -2.185 0.441 -2.981 1.242 L 9.915 9.399 z",
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 10,
      fill: "rgb(206,23,23)",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: " matrix(1 0 0 1 0 0) ",
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 81.368 83.833 c -0.509 0 -1.019 -0.196 -1.407 -0.587 l -13.653 -13.73 c -0.778 -0.782 -0.778 -2.049 0 -2.831 s 2.037 -0.782 2.815 0 l 13.653 13.73 c 0.778 0.782 0.778 2.049 0 2.831 C 82.386 83.637 81.877 83.833 81.368 83.833 z",
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 10,
      fill: "rgb(206,23,23)",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: " matrix(1 0 0 1 0 0) ",
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 29.281 31.45 c -0.509 0 -1.019 -0.196 -1.407 -0.587 L 13.877 16.787 c -0.778 -0.782 -0.778 -2.049 0 -2.831 c 0.777 -0.782 2.037 -0.782 2.815 0 l 13.996 14.076 c 0.778 0.782 0.778 2.049 0 2.831 C 30.3 31.255 29.79 31.45 29.281 31.45 z",
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 10,
      fill: "rgb(206,23,23)",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: " matrix(1 0 0 1 0 0) ",
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 88.009 48.067 c -1.099 0 -1.991 -0.896 -1.991 -2.002 c 0 -23.193 -18.762 -42.062 -41.824 -42.062 c -1.099 0 -1.991 -0.896 -1.991 -2.002 S 43.096 0 44.195 0 C 69.452 0 90 20.665 90 46.065 C 90 47.171 89.109 48.067 88.009 48.067 z",
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 10,
      fill: "rgb(206,23,23)",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: " matrix(1 0 0 1 0 0) ",
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 75.36 48.067 c -1.099 0 -1.991 -0.896 -1.991 -2.002 c 0 -16.178 -13.088 -29.341 -29.174 -29.341 c -1.099 0 -1.991 -0.896 -1.991 -2.002 s 0.891 -2.002 1.991 -2.002 c 18.282 0 33.155 14.958 33.155 33.345 C 77.351 47.171 76.459 48.067 75.36 48.067 z",
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 10,
      fill: "rgb(206,23,23)",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: " matrix(1 0 0 1 0 0) ",
    strokeLinecap: "round"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCall);
export default __webpack_public_path__ + "static/media/call.c87c3cb4be4d075cc2f5bc47133734ca.svg";
export { ForwardRef as ReactComponent };